import { createRoute, Navigate } from "@tanstack/react-router";
import { useSession } from "../auth-client";
import { Route as rootRoute } from "./__root";
import { LoadingScreen } from "@/frontend/components/onboarding/Onboarding";
import { ConsentView } from "@/frontend/components/consent/ConsentView";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/consent",
  component: ConsentPage,
  validateSearch: (search: Record<string, unknown>) => ({
    client_id: typeof search.client_id === "string" ? search.client_id : "",
    scope: typeof search.scope === "string" ? search.scope : "",
  }),
});

/** OAuth consent screen. Unauthenticated visitors are sent to login with the signed query intact. */
function ConsentPage() {
  const { data: session, isPending } = useSession();
  if (isPending) return <LoadingScreen />;
  if (!session)
    return (
      <Navigate to="/" search={Object.fromEntries(new URLSearchParams(window.location.search))} />
    );
  return <ConsentView />;
}
